<script lang="ts">
import { Themes } from '@/utils/helper-objects'
import { defineComponent } from 'vue'

/**
 * WinnersTicker banner.
 */
export default defineComponent({
  setup() {
    return {
      Themes,
    }
  },
})
</script>

<template>
  <AppBanner labelled-by="trustpilot" class="!px-0 @md/main:!px-8 relative">
    <div
      class="@md/main:rounded-md relative bg-black mask-squiggle"
      :style="{
        '--mask-squiggle-url': `url('/assets/images/masks/trustpilot-background.svg')`,
      }"
    >
      <div id="trustpilot" class="sr-only">
        {{ BUSINESS_NAME }} Winners Count
      </div>

      <div
        class="mx-auto flex w-full max-w-screen-xl flex-wrap items-center justify-around gap-y-4 p-5 @md/main:justify-between @md/main:rounded-lg relative"
      >
        <div
          class="mx-auto flex gap-3 @sm/main:gap-5 @xl/main:mx-0 @xl/main:gap-10"
        >
          <div class="flex items-center gap-3">
            <p
              class="flex h-10 w-10 items-center justify-center rounded-lg @md/main:h-14 @md/main:w-14 @md/main:bg-pure-white @md/main:p-2"
            >
              <img
                src="@/assets/images/cup.png"
                alt="Cup Icon"
                class="h-full"
              />
            </p>
            <p class="flex flex-col justify-center text-pure-white">
              <span class="font-black @md/main:leading-none md:text-xl">
                2.5 Million+
              </span>
              <span class="text-sm font-semibold">Prizes Won</span>
            </p>
          </div>

          <div class="flex items-center gap-3">
            <p
              class="flex h-10 w-10 items-center justify-center rounded-lg @md/main:h-14 @md/main:w-14 @md/main:bg-pure-white @md/main:p-2"
            >
              <img
                src="@/assets/images/money-bag.png"
                alt="Money Bag Icon"
                class="h-full"
              />
            </p>
            <p class="flex flex-col justify-center text-pure-white">
              <span class="font-black @md/main:text-xl @md/main:leading-none">
                {{
                  $n(20440359, 'currency', {
                    minimumFractionDigits: 0,
                  })
                }}+
              </span>
              <span class="text-sm font-semibold">Given in Prizes</span>
            </p>
          </div>

          <div class="hidden items-center gap-3 @sm/main:flex">
            <p
              class="flex h-10 w-10 items-center justify-center rounded-lg @md/main:h-14 @md/main:w-14 @md/main:bg-pure-white @md/main:p-2"
            >
              <img
                src="@/assets/images/heart.png"
                alt="Heart Icon"
                class="h-full"
              />
            </p>
            <p class="flex flex-col justify-center text-pure-white">
              <span class="font-black @md/main:text-xl @md/main:leading-none">
                {{ $n(550000) }}+
              </span>
              <span class="text-sm font-semibold">Followers</span>
            </p>
          </div>
        </div>

        <AppTrustpilot
          class="trustpilot-banner w-full py-2 hidden md:block @lg/main:w-fit @lg/main:rounded @lg/main:bg-black/50 @lg/main:px-6"
        />
      </div>
    </div>
  </AppBanner>
</template>

<style lang="scss" scoped>
.trustpilot-banner {
  :deep(iframe) {
    @apply min-[460px]:max-[1305px]:!h-[20px];
  }
}
</style>
